export const useErrorMessage = () => {
  const isDisplay = (errors, anotherCondition) => {
    if (!errors) return false;
    if (errors instanceof Object === true) {
      return Object.keys(errors).length > 0 && anotherCondition;
    } else {
      // Array、もしくはStringと判断
      return errors.length > 0 && anotherCondition;
    }
  };

  return { isDisplay };
};
